<template>
	<div class=" followuprecord">
		<leftnav class="fl" mkcode="E" itemcode="E-GJJL"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage">
				<div v-if="userdata.token">
					
				<!-- 标题盒子开始 -->
				<div class="whitebox right_topbox">
					<div class="right_boxtitle">
						<span class="fl right_title">跟进记录</span>
					</div>
					<table border="0" cellspacing="0" cellpadding="0">
						<tr>
							<td>企业名称</td>
							<td>
								<!-- <input type="text" placeholder="请输入姓名" class="inp_name"/> -->
								<el-input v-model="input" placeholder="请输入公司名称" class="inp_name"></el-input>
							</td>
						</tr>
						<tr>
							<td>跟进状态</td>
							<td><label v-for="(item,i) in checkList" class="pro_sutauslist" v-if="i>0"> <input type="checkbox"v-model="stauslist" :value="item.staus" />{{item.label}}</label></td>
						</tr>
						<tr>
							<td>录入时间</td>
							<td>
								<el-date-picker v-model="CreationTime" type="date" placeholder="选择日期" @change="dateFormat(1,CreationTime)">	</el-date-picker>
							</td>
						</tr>
						<!-- <tr>
									<td>最后跟进时间</td>
									<td> 
								<el-date-picker
								      v-model="LastTime"
								      type="date"
								      placeholder="选择日期"
														@change="dateFormat(2,LastTime)">
								 </el-date-picker>
									</td>
							</tr> -->
						<tr>
							<td>负责人</td>
							<td>
								<el-select v-model="personvalue" placeholder="请选择" clearable>
									<el-option  v-for="item in personoptions" :key="item.managerId" :label="item.managerName" :value="item.managerId">
									</el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td></td>
							<td>
								<p><span class="gov_screen" @click="gettracklist()">筛选</span><span class="rest_btn"
										@click="restfun()">重置</span></p>
							</td>
						</tr>
					</table>
				</div>
				<!-- 标题盒子结束 -->
				<!-- 纪录时间线开始 -->
				<div class="followuprecord_time whitebox">
					<div class="followuprecord_btn">
						<p class="fl">筛选出<span class="orangefont">&nbsp;{{totalRecord}}&nbsp;</span>项跟进记录</p>
						<ul class="fr">
							<!-- <li class="followuprecord_btn_li" @click="exportframe=true;exportlist()">导出记录</li> -->
							<li class="followuprecord_btn_li" @click="frame=true">添加记录</li>
						</ul>
					</div>
					<div class="followuprecord_timeline" v-for="item in tracklist">
						<div class="title">
							<h3 @click="detailrouterto('/workbenchEnterpriseDetails',item.customerId,item.stockCode)">
								{{item.customerName}}</h3>
							<span>负责人&nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.managerName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<span>跟进状态&nbsp;&nbsp;&nbsp;&nbsp;</span>
							<!-- <span>{{checkList[item.trackStatus].label}}</span> -->
							<span v-if="item.trackStatus ==0">待跟进</span>
							<span v-if="item.trackStatus ==1">初访</span>
							<span v-if="item.trackStatus ==2">有意向</span>
							<span v-if="item.trackStatus ==3">已签约</span>
							<span v-if="item.trackStatus ==4">已落地</span>
							<span v-if="item.trackStatus ==5">暂时搁置</span>
						</div>
						<el-timeline>
							<el-timeline-item :timestamp="item.contactTime " placement="top">
								<el-card>
									<h4><span>联系人&nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.contactName==''?'-':item.contactName}}</h4>
									<p>&nbsp;&nbsp;<span>备注 &nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.remark}}</p>
								</el-card>
							</el-timeline-item>
						</el-timeline>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="totalRecord" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
				<!-- 纪录时间线结束-->

				<!-- 添加跟进记录弹框 -->
				<div class="framebgbox" v-show="frame">
					<div class="framebox">
						<div class="frame">
							<h4>添加跟进记录</h4>
							<table border="0" cellspacing="0" cellpadding="0">
								<tr>
									<td>公司名称</td>
									<td>
										<el-select v-model="companyid" placeholder="请选择" @change="getcontactlist"><el-option v-for="item in companyoptions" :key="item.id"	:label="item.customerName" :value="item.id"></el-option></el-select>
									</td>
								</tr>
								<tr>
									<td>跟进时间</td>
									<td>
										<el-date-picker v-model="trackTime" type="datetime" placeholder="选择日期时间"
											@change="dateFormat(3,trackTime)">
										</el-date-picker>
									</td>
								</tr>
								<tr>
									<td>跟进状态</td>
									<td>
										<el-select v-model="trackStatusvalue" placeholder="请选择">
											<el-option v-for="item in trackStatusoptions" :key="item.staus"
												:label="item.label" :value="item.staus">
											</el-option>
										</el-select>
									</td>
								</tr>
								<tr>
									<td>联系人</td>
									<td>
										<el-select v-model="contactId" placeholder="请选择">
											<el-option v-for="item in contactlist" :key="item.id":label="item.contactName" :value="item.id"></el-option>
										</el-select>
									</td>
								</tr>
								<tr>
									<td>备 注</td>
									<td>
										<textarea v-model="addtrackremark" class="textareas"></textarea>
									</td>
								</tr>
								<tr>
									<td colspan="2" style="text-align: center;color: red;font-size: 14px;"
										v-show="erromsg !=''">{{erromsg}}</td>
								</tr>
							</table>
							<div class="frame_btn">
								<span class="frame_cancel" @click="frame=false">取消</span>
								<span class="frame_determine" @click="addtrackfun(0)">确定</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 添加跟进记录弹框end -->
				<!-- 导出纪录弹框 -->
				<!-- <div class="framebgbox" v-show="exportframe">
				<div class="framebox">
					<div class="frame">
					<h4>导出纪录</h4> 
					<table border="0" cellspacing="0" cellpadding="0"> 
						<tr>
							<td>客户名称</td>
							<td>  
							<el-select v-model="companyid" placeholder="请选择" >
								    <el-option
								      v-for="item in companyoptions"
								      :key="item.customerId"
								      :label="item.customerName"
								      :value="item.customerId" 
														>
								    </el-option>
								  </el-select>
							</td>
						</tr> 
					</table> 
					<div class="frame_btn"> 
						<span class="frame_cancel" @click="exportframe=false">取消</span>
						<span class="frame_determine" @click="exportlist()">确定</span>
					</div>
					</div>
				</div>
			</div> -->
				<!-- 添加跟进记录弹框end -->
			
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0"></freeUserTips>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'followuprecord',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title:"跟进记录",contactlist:[],
				userdata: {},
				checked: true,
				stauslist: [],
				checkList: [
					{
						staus: 0,
						label: '待跟进',
						ck: false
					},{
					staus: 1,
					label: '初访',
					ck: false
				}, {
					staus: 2,
					label: '有意向',
					ck: false
				}, {
					staus: 3,
					label: '已签约',
					ck: false
				}, {
					staus: 4,
					label: '已落地',
					ck: false
				}, {
					staus: 5,
					label: '暂时搁置',
					ck: false
				}],
				chargeoption: [],
				personoptions: [],
				trackStatusoptions: [{
					staus: 1,
					label: '初访',
					ck: false
				}, {
					staus: 2,
					label: '有意向',
					ck: false
				}, {
					staus: 3,
					label: '已签约',
					ck: false
				}, {
					staus: 4,
					label: '已落地',
					ck: false
				}, {
					staus: 5,
					label: '暂时搁置',
					ck: false
				}],
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 20, //每一页显示的数据条数
				totalRecord: 30, //记录总数
				totalPage:2,
				maxPage:10,  //最大页数
				personvalue: '',
				value: '',
				value1: '',
				input: '',
				frame: false, //添加纪录弹框
				exportframe: false, //导出弹框
				CreationTime: '', //创建时间
				LastTime: '', //最后跟进时间 
				tracklist: [ //跟进列表
					{
						cusname: "万科企业",
						trklist: [{
							lxr: "lianxiren",
							tiem: "2021-4-12"
						}, {
							lxr: "lianxiren2",
							tiem: "2021-4-12"
						}]
					},
					{
						cusname: "万科企业2",
						trklist: [{
							lxr: "lianxiren",
							tiem: "2021-4-12"
						}],
					},
				],
				trackTime: '', //添加纪录时间
				trackStatusvalue: '', //添加纪录跟进状态
				contactoptions: [],
				contactId: '', //联系人id
				addtrackremark: '', //添加纪录备注
				erromsg: '', //错误提示
				companyoptions: [],
				companyid: '',
			}
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			this.userdata = this.getuseriformation();
		 
		},
		mounted() {
			document.getElementById('app').style.background = "#f0f3f5";
			// this.bus.$emit('loading', false);
			if(this.userdata.token){
				this.pageHandler(1);
				this.getcompanyOp();
			}
			
		},
		methods: {
			pageHandler: function (page) {
				this.page = page; 
				this.gettracklist(page); 
			},
			restfun() {
				this.input = '';
				this.stauslist = [];
				this.CreationTime = '';
				this.personvalue = '';
				this.gettracklist();
			},
			//客户列表
			judeajaxurl(name, value) {
				var url1 = '';
				if (value != '' && value != null && value != 0) {
					url1 = '&' + name + '=' + value;
				}
				return url1;
			}, 
			//获取跟进列表
			gettracklist() {
				var _this = this;
				var ajaxurl = this.$api.crm.track.list()+'?';
				if (this.stauslist.length > 0) {
					var trackStatus = _this.stauslist.join(",")
					ajaxurl = ajaxurl+ 'trackStatus=' + trackStatus;
				}
				var customerName = this.judeajaxurl('customerName', this.input); //用户名称
				var enterDate = this.judeajaxurl('enterDate', this.CreationTime); //用户名称
				var managerId = this.judeajaxurl('managerId', this.personvalue); //用户名称
				ajaxurl=ajaxurl+customerName+enterDate+managerId; 
				this.$axios.get(ajaxurl, { headers: {AuthToken: this.userdata.token}}).then(function(res) {
					console.log("跟进列表", res); 
					// if (ajaxgetdata.length == 0) {
					// 	return;
					// } 
					if (res.data.code < 1) {
						var ajaxgetdata = res.data.list;
						_this.tracklist = ajaxgetdata; 
						_this.personoptions=_this.uniqueMid(ajaxgetdata);
						// _this.turndata(_this.tracklist);
						// _this.turndatatype(_this.tracklist);
						_this.pageSize=res.data.pageSize//每一页显示的数据条数
						_this.totalRecord=res.data.totalRecord//每一页显示的数据条数
						_this.totalPage=res.data.totalPage//每一页显示的数据条数   
						
						
						
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//选择公司时将联系人筛选出来
			getcontactlist(){
				console.log('companyoptions:',this.companyoptions);
				console.log(this.companyid);
				var pagecomid=this.companyid;
				var _this=this;
				this.companyoptions.forEach(list=>{
					if(pagecomid == list.id){
						_this.contactlist=list.contactList;
					}
				})
			},
			getcompanyOp(data){
				var opdata=[],_this=this,opdata1=[]; 
				this.$axios.get(this.$api.crm.customer.list(), {headers: { AuthToken: this.userdata.token }}).then(function(res) {
					if (res.data.success && res.data.list.length>0) { 
						var data1=res.data.list;
						// console.log('opdata',data1);
						for(var i=0;i<data1.length;i++){
							if(data1[i].stockCode == ''){
								opdata.push(data1[i]);
							}else{
								opdata1.push(data1[i])
							}
						}
						// _this.companyoptions=data1.filter((item)=>{return item.stockCode!=""}); 
						_this.companyoptions=_this.uniqueCid(opdata1).concat(opdata); 
						
						// console.log(_this.companyoptions,_this.uniqueCid(opdata1),opdata)
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
				// console.log('opdata',opdata); 
				
			}, 
			chachong(data){
				var data1=[];
				for(var i=0;i<data.length;i++){ 
					for(var d=1;d<data.length;d++){
						if(data[i].stockCode == data[d].stockCode && i != d){
							data.splice(i,1); 
						}
					}
				}
			 
				
			},
			turndatatype(datalist) {
				for (var i = 0; i < datalist.length; i++) {
					// datalist[i].year = datalist[i].publishTime.substring(0, 4) * 1;
					// datalist[i].date = datalist[i].publishTime.substring(5, datalist[i].publishTime.length);
					datalist[i].haseach = true;
				};
				var newdatelist = [{
					customerName: datalist[0].customerName,
					children: [datalist[0]]
				}];;
				datalist[0].haseach = false;
				for (var i = 0; i < datalist.length; i++) {
					var d = i + 1;
					if (d > datalist.length - 1) {
						d = datalist.length - 1
					}
					if (datalist[i].customerName == datalist[d].customerName && datalist[d].haseach) {
						newdatelist[newdatelist.length - 1].children.push(datalist[d]);
					} else if (datalist[i].customerName != datalist[d].customerName && datalist[d].haseach) {
						newdatelist.push({
							customerName: datalist[d].customerName,
							children: [datalist[d]]
						});
					}
					datalist[d].haseach = false;
				}
				// console.log(datalist)
				console.log('new', datalist, newdatelist);
				// this.pagedata = newdatelist; 
			},

			//数据
			turndata(data) {
				console.log('22313', data);
				var ndat = [{
					cusname: "万科企业",
					trklist: [{
						lxr: "lianxiren",
						tiem: "2021-4-12"
					}, {
						lxr: "lianxiren2",
						tiem: "2021-4-12"
					}]
				}, ];
				for (var i = 0; i < data.length; i++) {
					for (var j = i + 1; j < data.length; j++) {
						if (data[i].customerId == data[j].customerId) {
							console.log('重复纪录', data[i].customerName, i);

							// return false;
						}
					}
				}
				//去重，并添加次数
				// for (var i = 0;i < data.length; i++){
				//     for (var j = i+1;j < data.length;j++){
				//         if (data[i].customerId == data[j].customerId){ 
				// 									// ndat=[{cusname:}]
				// 									console.log(data[i]);
				//             j--; 
				//         }
				//     }
				// 				}
			}, 
			//负责人列表
			getmangerlist(data) {
				 
				console.log(managerNamearry);
				return managerNamearry;
			},

			//修改或添加跟进列表
			addtrackfun(trackId, cusid) {
				console.log(trackId, cusid)
				console.log(this.trackTime, this.trackStatusvalue, this.contactId, this.addtrackremark);
				var _this = this;
				if (this.contactId == '') {
					this.contactId = 0;
				}
				if (this.todoTime == '' || this.notifyTime == '') {
					this.erromsg = "列表不能为空";
				}
				$.ajax({
					type: "POST",
					url: this.$api.crm.track.post(),
					data: {
						trackId: trackId,
						customerId: _this.companyid,
						trackTime: _this.trackTime,
						trackStatus: _this.trackStatusvalue,
						contactId: _this.contactId,
						remark: _this.addtrackremark,
					},
					headers: {
						AuthToken: this.userdata.token
					},
					success: function(res) {
						console.log(res);
						if (res.success) {
							_this.frame = false; 
							_this.companyid=0;
							_this.trackTime="";
							_this.trackStatusvalue="";
							_this.contactId=0;
							_this.addtrackremark=""; 
							_this.gettracklist();
						}
					}
				})
			},
			//去重
			unique(arr) {
				const res = new Map();
				return arr.filter((arr) => !res.has(arr.customerId) && res.set(arr.customerId, 1));
			}, 
			uniqueMid(arr) {
				const res = new Map();
				return arr.filter((arr) => !res.has(arr.managerId) && res.set(arr.managerId, 1));
			},
			uniqueCid(arr){
				const res = new Map();
				return arr.filter((arr) => !res.has(arr.stockCode) && res.set(arr.stockCode, 1));
			},
			//导出纪录
			exportlist() {
				var _this = this;
				this.$axios.get(this.$api.crm.track.export(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log("导出纪录", res);
					if (res.data.success) {
						// alert("导出成功");
						_this.$message({
							type: 'success',
							message: '导出成功',
						});
						_this.gettracklist();
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//格式化日期 （时间戳）
			dateFormat(type, dateData) {
				var date = new Date(dateData);
				var M = date.getMonth() + 1;
				M = M < 10 ? ('0' + M) : M;
				var y = date.getFullYear();
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
				var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
				var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
				var time = y + '-' + M + '-' + d;
				var stime = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
				if (type == 1) {
					this.CreationTime = time;
				}
				if (type == 2) {
					this.LastTime = time;
				}
				if (type == 3) {
					this.trackTime = stime;
				}
				console.log(time);
				return time;
			},
			//企业详情跳转
			detailrouterto(path, id, code) {
				this.routerlinkarry(path, {
					type: 2,
					id: id,
					code: code
				});
			},
		}
	}
</script>

 
